import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import './Login.css';

const ResetPassword: React.FC = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [err, setErr] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr('');
    if (pw.length < 12) { setErr('Password must be at least 12 characters'); return; }
    if (!/[a-z]/.test(pw) || !/[A-Z]/.test(pw) || !/[0-9]/.test(pw)) {
      setErr('Password must include lowercase, uppercase, and a number');
      return;
    }
    if (pw !== pw2) { setErr('Passwords do not match'); return; }
    setLoading(true);
    try {
      const res = await fetch('/api/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword: pw }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setErr(data.error || 'Something went wrong');
        return;
      }
      setDone(true);
      setTimeout(() => navigate('/login', { replace: true }), 2000);
    } catch (e: any) {
      setErr(e.message);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-container">
        <div className="login-box">
          <h1>Cafe Ops Manager</h1>
          <h2>Reset password</h2>
          <p style={{ color: '#b00' }}>Missing reset token. Make sure you used the link from the email.</p>
          <p><Link to="/forgot-password">Request a new reset link</Link></p>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Cafe Ops Manager</h1>
        <h2>Set a new password</h2>
        {done ? (
          <p>Password updated. Taking you to sign in…</p>
        ) : (
          <form onSubmit={submit}>
            {err && <div className="error-message">{err}</div>}
            <div className="form-group">
              <label htmlFor="pw">New password</label>
              <input
                id="pw"
                type="password"
                value={pw}
                onChange={(e) => setPw(e.target.value)}
                required
                autoComplete="new-password"
                disabled={loading}
                minLength={12}
              />
              <small style={{ display: 'block', color: '#666', marginTop: 4 }}>
                Min 12 characters, with lowercase, uppercase, and a number.
              </small>
            </div>
            <div className="form-group">
              <label htmlFor="pw2">Confirm new password</label>
              <input
                id="pw2"
                type="password"
                value={pw2}
                onChange={(e) => setPw2(e.target.value)}
                required
                autoComplete="new-password"
                disabled={loading}
                minLength={12}
              />
            </div>
            <button type="submit" className="login-button" disabled={loading || !pw || !pw2}>
              {loading ? 'Updating…' : 'Update password'}
            </button>
            <p style={{ marginTop: '1rem', textAlign: 'center' }}>
              <Link to="/login">← Back to sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
